import React from 'react';
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectOpenTasksTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectOpenTasksTab/components/ProspectOpenTasksTabListing/ProspectOpenTasksTabListing";
import ProspectOpenTasksTabResume from "./components/ProspectOpenTasksTabResume/ProspectOpenTasksTabResume";
import BaseTaskTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseTaskTab/BaseTaskTab";


export default function ProspectOpenTasksTab() {
    const {currentRoute} = useNavigation();
    const {prospect: prospectId} = currentRoute.params;

    return (
        <BaseTaskTab
            listingComponent={<ProspectOpenTasksTabListing prospectId={prospectId} currentRoute={currentRoute}/>}
            resumeComponent={<ProspectOpenTasksTabResume prospectId={prospectId}/>}
            showResume={true}
        />
    )
}
